import { jsx as _jsx } from "react/jsx-runtime";
const ALT_TEKTS = {
    alt: 'Support logo',
};
export const SupportIcon = props => (_jsx("div", Object.assign({ className: "col-auto d-none d-md-block" }, { children: _jsx("img", { src: props.image, alt: ALT_TEKTS.alt }) })));
